import { createContext, useContext } from 'react'

// true, wenn die Route den Viewport füllt (Route-Flag fillViewport in
// src/routes). Nur dann darf eine Tabelle mit fillHeight die Resthöhe nehmen,
// sonst hätte ihr Scroll-Container keine Grenze und react-virtual würde jede
// Zeile rendern.
export const LayoutFillContext = createContext(false)

export const useLayoutFillsViewport = () => useContext(LayoutFillContext)
